export default __webpack_public_path__ + "static/middlebury-logo-18a76eaa865c515ef32efeb965b29d8a.png";